import { Mail, Clock } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import useMeta from "@/hooks/useMeta";
import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { CalendlyEmbed } from "@/components/site/CalendlyEmbed";
import { ContactForm } from "@/components/site/ContactForm";

export default function Book() {
  const { content } = useContent();
  const b = content.book;
  const s = content.settings;
  useMeta(
    "Book a free intro · Virtual therapy Ontario",
    "Book a free 20-minute phone intro or a 50-minute virtual session with Violeta Dubov, Registered Social Worker in Toronto, or send a message."
  );
  return (
    <>
      <PageHero eyebrow="Book / Contact" title={b.headline} testId="book-headline">{b.body}</PageHero>
      <section className="wrap pb-16">
        <CalendlyEmbed book={b} consultUrl={s.calendly_consult_url} sessionUrl={s.calendly_session_url} couplesUrl={s.calendly_couples_url} />
      </section>
      <section className="wrap grid gap-10 pb-20 md:grid-cols-[0.8fr_1.2fr] md:gap-16" aria-labelledby="contact-title">
        <Reveal>
          <h2 id="contact-title" className="text-3xl text-[#22304A] sm:text-4xl">Send a message</h2>
          <p className="mt-5 flex items-start gap-3 text-[#22304A]/80" data-testid="contact-reply-note">
            <Clock className="mt-1 h-4 w-4 shrink-0 text-[#6F5B9E]" aria-hidden="true" /> {b.reply_note}
          </p>
          <p className="mt-3 flex items-start gap-3">
            <Mail className="mt-1 h-4 w-4 shrink-0 text-[#6F5B9E]" aria-hidden="true" />
            <a href={`mailto:${s.contact_email}`} className="text-link break-all" data-testid="contact-email-link">{s.contact_email}</a>
          </p>
        </Reveal>
        <Reveal delay={120} className="relative">
          <ContactForm book={b} />
        </Reveal>
      </section>
    </>
  );
}
